export enum GridNames {
    productsGrid = "productsGrid",
    invoiceGrid = "invoiceGrid",
    orderGrid = "orderGrid",
    portalOrderGrid = "portalOrderGrid"
}
